export default {
  'pages.covenantDevice.mac': 'MAC地址',
  'pages.admin.providerCard.config.grpcAddr': 'gRPC地址',
  'pages.admin.providerCard.config.funasrAddr': 'funasr地址',
  'pages.covenantDevice.cardTitle': '協約設備管理',
  'pages.admin.whitelist.mac': 'MAC地址',
  'pages.covenantDevice.operations': '操作',
  'pages.covenantDevice.expireTime': '到期時間',
  'pages.covenantDevice.updateTime': '更新時間',
  'pages.admin.devices': '設備管理',
  'pages.admin.unbindDevice': '設備解綁',
  'pages.unbindDevice.titleAdmin': '設備解綁（需管理員權限）',
  'pages.unbindDevice.inputPlaceholder': '請輸入設備ID',
  'pages.unbindDevice.unbind': '解綁',
  'pages.unbindDevice.unbinding': '解綁中...',
  'pages.unbindDevice.success': '解綁成功',
  'pages.unbindDevice.fail': '解綁失敗',
  'pages.layouts.userLayout.title': '管理控制台',
  'pages.login.accountLogin.tab': '賬戶密碼登錄',
  'pages.login.accountLogin.errorMessage': '錯誤的用戶名和密碼',
  'pages.register': '新用戶註冊',
  'pages.login.failure': '登錄失敗，請重試！',
  'pages.login.success': '登錄成功！',
  'pages.login.username.placeholder': '用戶名',
  'pages.login.username.required': '用戶名是必填項！',
  'pages.login.password.placeholder': '密碼',
  'pages.login.password.required': '密碼是必填項！',
  'pages.login.phoneLogin.tab': '手機號登錄',
  'pages.login.phoneLogin.errorMessage': '驗證碼錯誤',
  'pages.login.phoneNumber.placeholder': '請輸入手機號！',
  'pages.login.phoneNumber.required': '手機號是必填項！',
  'pages.login.phoneNumber.invalid': '不合法的手機號！',
  'pages.login.captcha.placeholder': '請輸入驗證碼！',
  'pages.login.captcha.required': '驗證碼是必填項！',
  'pages.login.phoneLogin.getVerificationCode': '獲取驗證碼',
  'pages.getCaptchaSecondText': '秒後重新獲取',
  'pages.login.rememberMe': '自動登錄',
  'pages.login.forgotPassword': '忘記密碼 ?',
  'pages.login.submit': '登錄',
  'pages.login.loginWith': '其他登錄方式 :',
  'pages.login.registerAccount': '註冊賬戶',
  'pages.welcome.link': '歡迎使用',
  'pages.welcome.alertMessage': '更快更強的重型組件，已經發布。',
  'pages.404.subTitle': '抱歉，您訪問的頁面不存在。',
  'pages.404.buttonText': '返回首頁',
  'pages.admin.subPage.title': ' 這個頁面只有 admin 權限才能查看',
  'pages.admin.subPage.alertMessage': 'umi ui 現已發佈，歡迎使用 npm run ui 啟動體驗。',
  'pages.searchTable.createForm.newRule': '新建規則',
  'pages.searchTable.updateForm.ruleConfig': '規則配置',
  'pages.searchTable.updateForm.basicConfig': '基本信息',
  'pages.searchTable.updateForm.ruleName.nameLabel': '規則名稱',
  'pages.searchTable.updateForm.ruleName.nameRules': '請輸入規則名稱！',
  'pages.searchTable.updateForm.ruleDesc.descLabel': '規則描述',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder': '請輸入至少五個字符',
  'pages.searchTable.updateForm.ruleDesc.descRules': '請輸入至少五個字符的規則描述！',
  'pages.searchTable.updateForm.ruleProps.title': '配置規則屬性',
  'pages.searchTable.updateForm.object': '監控對象',
  'pages.searchTable.updateForm.ruleProps.templateLabel': '規則模板',
  'pages.searchTable.updateForm.ruleProps.typeLabel': '規則類型',
  'pages.searchTable.updateForm.schedulingPeriod.title': '設定調度週期',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': '開始時間',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules': '請選擇開始時間！',
  'pages.searchTable.titleDesc': '描述',
  'pages.searchTable.ruleName': '規則名稱為必填項',
  'pages.searchTable.titleCallNo': '服務調用次數',
  'pages.searchTable.titleStatus': '狀態',
  'pages.searchTable.nameStatus.default': '關閉',
  'pages.searchTable.nameStatus.running': '運行中',
  'pages.searchTable.nameStatus.online': '已上線',
  'pages.searchTable.nameStatus.abnormal': '異常',
  'pages.searchTable.titleUpdatedAt': '上次調度時間',
  'pages.searchTable.exception': '請輸入異常原因！',
  'pages.searchTable.titleOption': '操作',
  'pages.searchTable.config': '配置',
  'pages.searchTable.subscribeAlert': '訂閱警報',
  'pages.searchTable.title': '查詢表格',
  'pages.searchTable.new': '新建',
  'pages.searchTable.chosen': '已選擇',
  'pages.searchTable.item': '項',
  'pages.searchTable.totalServiceCalls': '服務調用次數總計',
  'pages.searchTable.tenThousand': '萬',
  'pages.searchTable.batchDeletion': '批量刪除',
  'pages.searchTable.batchApproval': '批量審批',

  // Agents 页面相关文本
  'pages.agents.search.placeholder': '搜索智能體',
  'pages.agents.create.button': '新建智能體',
  'pages.agents.addDevice.button': '添加設備',
  'pages.agents.create.modal.title': '新建智能體',
  'pages.agents.create.modal.nameLabel': '智能體名稱',
  'pages.agents.create.modal.placeholder': '請輸入智能體名稱',
  'pages.agents.card.id': 'ID',
  'pages.agents.card.voiceModel': '角色音色',
  'pages.agents.card.languageModel': '語言模型',
  'pages.agents.card.lastChat': '最近對話',
  'pages.agents.card.conversationId': '會話ID',
  'pages.agents.card.clearConversation': '清除會話ID',
  'pages.agents.card.clearConversation.success': '會話ID已清除',
  'pages.agents.card.clearConversation.error': '清除會話ID失敗',
  'pages.agents.card.configRole': '配置角色',
  'pages.agents.card.voiceRecognition': '聲紋識別',
  'pages.agents.card.voiceRecognition.developing': '功能開發中，敬請期待',
  'pages.agents.card.historyDialog': '歷史對話',
  'pages.agents.card.manageDevice': '管理設備',
  'pages.agents.card.addDevice': '添加設備',
  'pages.agents.loading': '加載智能體列表中...',
  'pages.agents.reload': '重新加載',
  'pages.agents.empty.title': '暫無智能體',
  'pages.agents.empty.createFirst': '創建第一個智能體',
  'pages.agents.delete.title': '確定刪除智能體',
  'pages.agents.delete.content': '刪除智能體後，該智能體有關配置（包括設備相關的對話記錄）將無法恢復。確定刪除嗎？',
  'pages.agents.delete.confirm': '確認刪除',
  'pages.agents.fetch.error': '獲取智能體列表失敗',
  'pages.agents.network.error': '網絡錯誤，請稍後重試',
  'pages.agents.speed.patient': '耐心',
  'pages.agents.speed.normal': '正常',
  'pages.agents.speed.fast': '快速',
  'pages.agents.lastChat.none': '無',
  'pages.agents.language.chinese': '中文',
  'pages.agents.loading.tts.error': '加載TTS音色失敗',
  'pages.agents.loading.llm.error': '加載LLM提供者失敗',
  'pages.agents.sort.id': '按 ID 排序',
  'pages.agents.sort.updatedAt': '按最近修改排序',
  'pages.agents.sort.lastConversationAt': '按最近對話排序',

  // Register 页面相关文本
  'pages.register.title': '註冊',
  'pages.register.form.title': '註冊新賬戶',
  'pages.register.submit': '註冊',
  'pages.register.username.placeholder': '請輸入用戶名',
  'pages.register.username.required': '請輸入用戶名！',
  'pages.register.username.min': '用戶名至少4個字符',
  'pages.register.email.placeholder': '請輸入郵箱',
  'pages.register.email.required': '請輸入郵箱！',
  'pages.register.email.invalid': '請輸入有效的郵箱地址！',
  'pages.register.password.placeholder': '請輸入密碼',
  'pages.register.password.required': '請輸入密碼！',
  'pages.register.password.min': '密碼至少6個字符',
  'pages.register.password.pattern': '密碼必須包含大小寫字母和數字',
  'pages.register.confirmPassword.placeholder': '請確認密碼',
  'pages.register.confirmPassword.required': '請確認密碼！',
  'pages.register.confirmPassword.min': '密碼至少6個字符',
  'pages.register.error.passwordMismatch': '兩次輸入的密碼不一致',
  'pages.register.error.registerFailed': '註冊失敗，請重試！',
  'pages.register.success': '註冊成功！',

  // Login 页面相关文本
  'pages.login.title': 'Anime AI Chat 管理控制台',
  'pages.login.actionIcons.notImplemented': '暫未實現，敬請期待',
  'pages.login.mobile.captchaError': '驗證碼錯誤',
  'pages.login.captcha.success': '獲取驗證碼成功！驗證碼為：1234',
  'pages.login.forgotPassword.contactAdmin': '請聯繫管理員',
  'pages.login.mobile.notAvailable': '此功能暫未開放，請使用賬戶密碼登錄',

  // AgentSetting 页面相关文本
  'pages.agentSetting.title': '配置角色',
  'pages.agentSetting.back': '返回',
  'pages.agentSetting.roleTemplate.title': '角色模板',
  'pages.agentSetting.roleTemplate.label': '模板',
  'pages.agentSetting.template.taiwanGirlfriend': '臺灣女友',
  'pages.agentSetting.template.potato': '土豆子',
  'pages.agentSetting.template.englishTutor': 'English Tutor',
  'pages.agentSetting.template.curiousBoy': '好奇小男孩',
  'pages.agentSetting.template.puppyLeader': '汪汪隊長',
  'pages.agentSetting.basicConfig.title': '基礎配置',
  'pages.agentSetting.assistantName.label': '助手暱稱',
  'pages.agentSetting.assistantName.placeholder': '請輸入助手暱稱',
  'pages.agentSetting.assistantName.required': '請輸入助手暱稱',
  'pages.agentSetting.dialogLanguage.label': '對話語言',
  'pages.agentSetting.dialogLanguage.placeholder': '選擇對話語言',
  'pages.agentSetting.voiceType.label': '角色音色',
  'pages.agentSetting.voiceType.placeholder': '選擇角色音色',
  'pages.agentSetting.roleDescription.title': '角色介紹',
  'pages.agentSetting.roleDescription.label': '角色介紹',
  'pages.agentSetting.roleDescription.placeholder': '請輸入角色介紹',
  'pages.agentSetting.roleDescription.required': '請輸入角色介紹',
  'pages.agentSetting.languageModel.title': '語言模型',
  'pages.agentSetting.languageModel.label': '語言模型',
  'pages.agentSetting.languageModel.placeholder': '選擇語言模型',
  'pages.agentSetting.languageModel.tip': '改變模型後，建議清空記憶體，以免影響聊天體驗。',
  'pages.agentSetting.advancedSettings.expand': '展開高級設置',
  'pages.agentSetting.advancedSettings.collapse': '收起高級設置',
  'pages.agentSetting.recognitionSpeed.label': '語音識別速度',
  'pages.agentSetting.recognitionSpeed.placeholder': '選擇識別速度',
  'pages.agentSetting.speechSpeed.label': '角色語速',
  'pages.agentSetting.speechSpeed.placeholder': '選擇語速',
  'pages.agentSetting.pitchValue.label': '角色音量',
  'pages.agentSetting.button.reset': '重置',
  'pages.agentSetting.button.save': '保存',
  'pages.agentSetting.save.success': '保存成功',
  'pages.agentSetting.save.error': '保存失敗',
  'pages.agentSetting.save.missingId': '缺少 agent id，無法保存',
  'pages.agentSetting.load.tts.error': '加載TTS音色失敗',
  'pages.agentSetting.speed.slow': '慢速',
  'pages.agentSetting.speed.normal': '正常',
  'pages.agentSetting.speed.fast': '快速',
  'pages.agentSetting.speed.patient': '耐心',
  'pages.agentSetting.language.chinese': '普通話',
  'pages.agentSetting.language.english': '英語',
  'pages.agentSetting.language.spanish': '西班牙語',
  'pages.agentSetting.language.french': '法語',
  'pages.agentSetting.language.german': '德語',
  'pages.agentSetting.language.japanese': '日語',
  'pages.agentSetting.language.korean': '韓語',
  'pages.agentSetting.language.portuguese': '葡萄牙語',
  'pages.agentSetting.language.arabic': '阿拉伯語',
  'pages.agentSetting.language.russian': '俄語',
  'pages.agentSetting.language.italian': '意大利語',
  'pages.agentSetting.language.turkish': '土耳其語',
  'pages.agentSetting.language.polish': '波蘭語',
  'pages.agentSetting.language.catalan': '加泰羅尼亞語',
  'pages.agentSetting.mcp.modal.title': 'MCP接入點',
  'pages.agentSetting.mcp.modal.statusLabel': '接入點狀態',
  'pages.agentSetting.mcp.modal.online': '在線',
  'pages.agentSetting.mcp.modal.disconnected': '未連接',
  'pages.agentSetting.mcp.modal.unknown': '未連接',
  'pages.agentSetting.mcp.modal.refresh': '刷新',
  'pages.agentSetting.mcp.modal.enabledServices': '啓用的服務',
  'pages.agentSetting.mcp.modal.endpointLabel': '接入點地址',
  'pages.agentSetting.mcp.modal.endpointDesc': '以下是智能體的MCP接入點地址。',
  'pages.agentSetting.mcp.modal.docLink': '查看接入點使用文檔',
  'pages.agentSetting.mcp.modal.noEndpoint': '無可用接入點',
  'pages.agentSetting.mcp.modal.hide': '隱藏',
  'pages.agentSetting.mcp.modal.show': '顯示',
  'pages.agentSetting.mcp.modal.copied': '已複製',
  'pages.agentSetting.mcp.modal.copy': '複製',
  'pages.agentSetting.mcp.title': 'MCP設置',
  'pages.agentSetting.mcp.officialServices': '官方服務',
  'pages.agentSetting.mcp.officialServices.placeholder': '選擇官方服務',
  'pages.agentSetting.mcp.services.weather': '天氣',
  'pages.agentSetting.mcp.services.joke': '笑話',
  'pages.agentSetting.mcp.services.music': '音樂',
  'pages.agentSetting.mcp.services.news': '新聞',
  'pages.agentSetting.mcp.customService': '自定義服務',
  'pages.agentSetting.mcp.error.missingId': '缺少 agent id，無法獲取接入點',
  'pages.agentSetting.mcp.error.noEndpoint': '無法從服務端獲取接入點',
'pages.agentSetting.mcp.error.fetchFailed': '獲取接入點失敗',
  'pages.agentSetting.mcp.button.getEndpoint': '獲取 MCP 接入點',

  // Memory settings
  'pages.agentSetting.memory.title': '短期記憶',
  'pages.agentSetting.memory.type.label': '記憶類型',
  'pages.agentSetting.memory.type.none': '無記憶',
  'pages.agentSetting.memory.type.shortTerm': '短期記憶',
  'pages.agentSetting.memory.current.label.short': '當前記憶',
  'pages.agentSetting.memory.current.help': '每次對話後重新生成',
  'pages.agentSetting.memory.clear': '清除記憶',
  'pages.agentSetting.memory.clear.tip': '記憶已標記為清除，請點擊保存以應用生效',
  'pages.agentSetting.memory.content.label': '記憶內容',
  'pages.agentSetting.memory.content.placeholder': '獲取當前智能體最新短期記憶內容',
  'pages.agentSetting.memory.content.editPlaceholder': '請輸入記憶內容',
  'pages.agentSetting.memory.edit': '編輯記憶',
  'pages.agentSetting.memory.edit.success': '記憶已更新，請在保存後生效',
  'pages.agentSetting.memory.edit.save': '保存修改',
  'pages.agentSetting.memory.edit.cancel': '取消',

  'pages.agentSetting.roleTemplate.empty': '暫無模板，請檢查 role_template.json',
  'pages.admin.providerModal.save': '保存',
  'pages.admin.providerModal.copyAsNew': '複製為新的供應商',

  // 通用按鈕和操作
  'pages.common.cancel': '取消',

  // 系統配置相關
  'pages.admin.systemConfig.roleName': '角色名稱',
  'pages.admin.systemConfig.roleDesc': '角色描述',
  'pages.admin.systemConfig.enabled': '啟用狀態',
  'pages.admin.systemConfig.featureName': '功能名稱',
  'pages.admin.systemConfig.featureDesc': '功能描述',
  'pages.admin.systemConfig.exitCommand': '退出指令',
  'pages.admin.systemConfig.mcpName': 'MCP名稱',
  'pages.admin.systemConfig.newNameOptional': '新名稱（可選）',
  'pages.admin.systemConfig.configJson': '配置JSON',
  'pages.admin.systemConfig.useDeviceCode': '使用設備代碼',
  'pages.admin.systemConfig.quickReply': '快速回覆',
  'pages.admin.systemConfig.shortTermMemory': '短期記憶',
  'pages.admin.systemConfig.saveUserAudio': '保存用戶音頻文件',
  'pages.admin.systemConfig.enableWhiteList': '啟用白名單',
  'pages.admin.systemConfig.speakerDetect': '聲紋識別',
  'pages.admin.systemConfig.recorderManagerEnable': '啟用錄音管理',
  'pages.admin.systemConfig.voiceCloneEnable': '啟用聲音克隆',
  'pages.admin.systemConfig.flattenedChatHistory': '扁平化聊天歷史',
  'pages.admin.systemConfig.dialogueHistoryLength': '對話歷史長度',
  'pages.admin.systemConfig.userTotalQuota': '用戶總額度',
  'pages.admin.systemConfig.dailyClearQuota': '每日清除額度',
  'pages.admin.systemConfig.checkDeviceModeImmediately': '立即檢查設備模式',
  'pages.admin.systemConfig.defaultObserverUserOnRegister': '新註冊用戶預設觀察者角色',
  'pages.admin.systemConfig.status': '啟用狀態',
  'pages.admin.systemConfig.port': '端口',
  'pages.admin.systemConfig.udpShowPort': '顯示端口',
  'pages.admin.systemConfig.accessToken': '訪問令牌',
  'pages.admin.systemConfig.activateText': '激活文本',
  'pages.admin.systemConfig.logLevel': '日誌級別',
  'pages.admin.systemConfig.logDir': '日誌目錄',
  'pages.admin.systemConfig.logFileName': '日誌文件名',

  // 聲音克隆相關
  'pages.console.voiceClone.name': '名稱',
  'pages.console.voiceClone.provider': '提供商',
  'pages.console.voiceClone.mode': '模式',
  'pages.console.voiceClone.record': '錄音',
  'pages.console.voiceClone.upload': '上傳',

  // 聲紋識別相關
  'pages.console.speakers.name': '名稱',
  'pages.console.speakers.mode': '模式',
  'pages.console.speakers.record': '錄音',
  'pages.console.speakers.upload': '上傳',

  // 設定頁面相關
  'pages.console.settings.email': '郵箱',
  'pages.console.settings.oldPassword': '舊密碼',
  'pages.console.settings.newPassword': '新密碼',
  'pages.console.settings.confirmNewPassword': '確認新密碼',

  // VLLM提供商相關
  'pages.providers.vllm.maxPixels': '最大像素數',

  'pages.unbindDevice.cardTitle': '設備解綁',
  'pages.whiteList.cardTitle': '白名單管理',
  'pages.admin.ops.logViewer.previewTitle': '日誌預覽',
  'pages.admin.ops.logViewer.fileName': '檔案名稱：',
  'pages.admin.ops.logViewer.lineCount': '行數：',
  'pages.admin.ops.logViewer.previewBtn': '預覽',
  'pages.admin.ops.logViewer.noContent': '暫無內容',
  'pages.admin.deviceManage': '設備管理',
  'pages.systemConfig.quickReply': '快速回覆',
  'pages.systemConfig.useShortTermMemory': '短期記憶',
  'pages.systemConfig.useShortTermMemory.desc': '開啟後，系統使用短期記憶機制，每輪對話後更新短期記憶。關閉則不使用短期記憶。',
  'pages.admin.providerModal.model.label': '模型 *',
  'pages.admin.providerModal.model.placeholder': '請輸入模型名稱',
  'pages.admin.providerModal.model.required': '請輸入模型名稱',
  'pages.admin.providerModal.security.title': '安全設置',
  'pages.admin.providerModal.grpc.addr.label': 'gRPC地址（主機:端口）*',
  'pages.admin.providerModal.grpc.addr.required': '請輸入gRPC地址（主機:端口）',
  'pages.admin.settings.voiceCloneEnable': '啟用聲音克隆',
  'pages.contractDevice.cardTitle': '協約設備管理',
  'pages.contractDevice.mac': 'MAC地址',
  'pages.contractDevice.protocolType': '協議類型',
  'pages.contractDevice.status': '狀態',
  'pages.contractDevice.expireTime': '到期時間',
  'pages.contractDevice.updateTime': '更新時間',
  'pages.contractDevice.operations': '操作',
  'pages.contractDevice.edit': '編輯',
  'pages.contractDevice.delete': '刪除',
  'pages.contractDevice.deleteConfirm': '確認刪除',
  'pages.contractDevice.addTitle': '添加協約設備',
  'pages.contractDevice.batchAddTitle': '批量添加',
  'pages.contractDevice.editTitle': '編輯協約設備',
  'pages.contractDevice.listTitle': '協約設備列表',
  'pages.contractDevice.add': '添加',
  'pages.contractDevice.batchAdd': '批量添加',
  'pages.contractDevice.selectCsvTip': '請選擇一個csv文件',
  'pages.contractDevice.uploadSuccess': '上傳成功',
  'pages.contractDevice.macRequired': '請輸入MAC地址',
  'pages.contractDevice.protocolTypeRequired': '請選擇協議類型',
  'pages.contractDevice.statusRequired': '請選擇狀態',
  'pages.contractDevice.expireTimeRequired': '請選擇到期時間',
};